export const FETCH_APIKEY_REQUEST = 'FETCH_APIKEY_REQUEST';
export const FETCH_APIKEY_SUCCESS = 'FETCH_APIKEY_SUCCESS';
export const FETCH_APIKEY_FAILURE = 'FETCH_APIKEY_FAILURE';

export const CREATE_APIKEY_REQUEST = 'CREATE_APIKEY_REQUEST';
export const CREATE_APIKEY_SUCCESS = 'CREATE_APIKEY_SUCCESS';
export const CREATE_APIKEY_FAILURE = 'CREATE_APIKEY_FAILURE';

export const DELETE_APIKEY_REQUEST = 'DELETE_APIKEY_REQUEST';
export const DELETE_APIKEY_SUCCESS = 'DELETE_APIKEY_SUCCESS';
export const DELETE_APIKEY_FAILURE = 'DELETE_APIKEY_FAILURE';

// Action Creators for Fetching Agents
export const fetchApiKeyRequest = () => ({
  type: FETCH_APIKEY_REQUEST,
});
export const fetchApiKeySuccess = (apiKey) => ({
  type: FETCH_APIKEY_SUCCESS,
  payload: apiKey,
});
export const fetchApiKeyFailure = (error) => ({
  type: FETCH_APIKEY_FAILURE,
  payload: error,
});

// Action Creators for Creating Agents
export const createApiKeyRequest = ({ data = {}, meta = {}, callback } = {}) => ({
  type: CREATE_APIKEY_REQUEST,
  payload: { data, meta },
  callback,
}); 

export const createApiKeySuccess = (apiKey) => ({
  type: CREATE_APIKEY_SUCCESS,
  payload: apiKey,
});

export const createApiKeyFailure = (error) => ({
  type: CREATE_APIKEY_FAILURE,
  payload: error,
});

export const deleteApiKeyRequest = ({ id, meta }) => ({
  type: DELETE_APIKEY_REQUEST,
  payload: { id, meta },
});

export const deleteApiKeySuccess = (apiKey) => ({
  type: DELETE_APIKEY_SUCCESS,
  payload: apiKey
})

export const deleteApiKeyFailure = (error) => ({
  type: DELETE_APIKEY_FAILURE,
  payload: error
})  